import { ReactComponent as BrandVsNonBrand } from '../assets/brand-vs-non-brand.svg';
import { ReactComponent as ClosersVsNonClosers } from '../assets/closers-vs-non-closers.svg';
import { ReactComponent as ConceptScreening } from '../assets/concept-screening.svg';
import { ReactComponent as ExpandersContractors } from '../assets/expanders-contractors.svg';
import { ReactComponent as GenericPlaceholder } from '../assets/generic-placeholder.svg';
import { ReactComponent as HeavyMediumLight } from '../assets/heavy-medium-light.svg';
import { ReactComponent as LapsedRepeatNew } from '../assets/lapsed-repeat-new.svg';
import { ReactComponent as LapsingBrand } from '../assets/lapsing-brand.svg';
import { ReactComponent as Leakage } from '../assets/leakage.svg';
import { ReactComponent as Monadic } from '../assets/monadic.svg';
import { ReactComponent as NewItemLaunch } from '../assets/new-item-launch.svg';
import { ReactComponent as NewItem } from '../assets/new-item.svg';
import { ReactComponent as Promo } from '../assets/promo.svg';
import { ReactComponent as PurchaseJourney } from '../assets/purchase-journey.svg';
import { ReactComponent as QuickPulse } from '../assets/quick-pulse.svg';
import { ReactComponent as TURF } from '../assets/turf.svg';
import { ReactComponent as Video } from '../assets/video.svg';

export { ReactComponent as LapsingBrand } from '../assets/lapsing-brand.svg';

/**
 * gets survey icon based on id
 * @param  {String} id
 * @return {Node}   react component
 */
export const getSurveyIcon = (id) => {
  switch (id) {
    case 'brand-vs-non-brand-buyers-v3-instant-survey-type':
      return <BrandVsNonBrand />;
    case 'closers-vs-non-closers-v3-instant-survey-type':
      return <ClosersVsNonClosers />;
    case 'concept-screening-instant-survey-type':
    case 'concept-screening-v2-instant-survey-type':
    case 'concept-screening-v3-instant-survey-type':
    case 'concept-test-v3-instant-survey-type':
      return <ConceptScreening />;
    case 'expanders-contractors-v3-instant-survey-type':
      return <ExpandersContractors />;
    case 'heavy-medium-light-v3-instant-survey-type':
      return <HeavyMediumLight />;
    case 'lapsing-brand-instant-survey-type':
    case 'lapsing-brand-v2-instant-survey-type':
    case 'lapsing-brand-v3-instant-survey-type':
      return <LapsingBrand />;
    case 'lapsed-repeat-new-instant-survey-type':
    case 'lapsed-repeat-new-v3-instant-survey-type':
      return <LapsedRepeatNew />;
    case 'leakage-instant-survey-type':
    case 'leakage-v2-instant-survey-type':
    case 'leakage-v3-instant-survey-type':
      return <Leakage />;
    case 'monadic-concept-test-v3-instant-survey-type':
      return <Monadic />;
    case 'new-item-launch-instant-survey-type':
      return <NewItemLaunch />;
    case 'new-item-v3-instant-survey-type':
      return <NewItem />;
    case 'promo-instant-survey-type':
    case 'buyer-instant-survey-type':
    case 'buyer-v2-instant-survey-type':
    case 'buyer-v3-instant-survey-type':
    case 'standard-v3-instant-survey-type':
      return <Promo />;
    case 'purchase-journey-instant-survey-type':
    case 'purchase-journey-v2-instant-survey-type':
    case 'purchase-journey-v3-instant-survey-type':
      return <PurchaseJourney />;
    case 'quick-pulse-instant-survey-type':
    case 'quick-pulse-v2-instant-survey-type':
    case 'quick-pulse-v3-instant-survey-type':
      return <QuickPulse />;
    case 'turf-v3-instant-survey-type':
      return <TURF />;
    case 'video-survey-v3-instant-survey-type':
      return <Video />;
    default:
      return <GenericPlaceholder />;
  }
};
